"use client";

import React, { useEffect } from "react";
import Link from "next/link";
import { useConvexAuth } from "convex/react";
import { HugeiconsIcon } from "@hugeicons/react";
import { Cancel01Icon } from "@hugeicons/core-free-icons";
import { useBoard } from "@/components/BoardProvider";
import { PricingOfferPanel } from "@/components/pricing/PricingOfferPanel";
import { captureClientEvent } from "@/lib/analytics/client";

export default function PricingPage() {
  const board = useBoard();
  const { isAuthenticated } = useConvexAuth();

  useEffect(() => {
    captureClientEvent("pricing_page_viewed", {});
  }, []);

  // Full-bleed offer with no surrounding chrome. data-themed + data-board switch
  // --primary from the landing black to the board accent, so this reads like the
  // dashboard paywall rather than the marketing site.
  return (
    <main
      data-themed
      data-board={board.id}
      className="fixed inset-0 z-50 overflow-y-auto bg-background text-foreground"
    >
      {/* This page covers the whole viewport, so without this the only way out
          is the browser's back button. Signed-in readers go back to where they
          study; everyone else to the marketing site. */}
      <Link
        href={isAuthenticated ? "/dashboard" : "/"}
        aria-label="Close"
        onClick={() => captureClientEvent("pricing_page_dismissed", {})}
        className="absolute right-4 top-4 z-20 flex h-9 w-9 items-center justify-center rounded-full bg-white/15 text-white transition-colors hover:bg-white/25 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/50 lg:right-5 lg:top-5 lg:bg-muted lg:text-muted-foreground lg:hover:text-foreground lg:focus-visible:ring-ring"
      >
        <HugeiconsIcon icon={Cancel01Icon} size={20} strokeWidth={1.8} />
      </Link>
      <PricingOfferPanel className="min-h-full" />
    </main>
  );
}
